{
  "title": "What to Do When Registration Shows \"Needs Update\"",
  "description": "Why your registration can show \"Needs update\", where you will see it, and how to fix it; this does not change your team or registration status.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, your registration matches the current registration form again and the \"Needs update\" marker disappears.",
  "roleNote": "Participant",
  "prerequisites": [
    "You have joined or created a team and saved your registration before",
    "This competition's registration deadline has not passed"
  ],
  "pathLabel": "My Competitions / Home → Competition page → Registration details",
  "steps": [
    {
      "title": "1. Recognize the \"Needs update\" marker",
      "description": "When your saved answers no longer fit the current published registration form, the \"My Competitions\" card shows \"Registration (needs update)\", Home adds a to-do for it, and the Registration details card on the competition page shows \"Registration needs an update\" with the names of the missing fields. Common causes: the organizer changed the form and added a required field, or a required checkbox (for example the Team declaration) is not ticked."
    },
    {
      "title": "2. Open the form and fill in the gaps",
      "description": "On the competition page's Registration details card, click \"Fill in registration\", fill in the fields the page points out, and press \"Save changes\". The system never ticks a declaration for you; you have to read and tick it yourself."
    },
    {
      "title": "3. Confirm the marker is gone",
      "description": "After a successful save the marker disappears from the card, Home and the competition page. If the organizer sent a reminder email, you can also follow the link in it to the competition page."
    }
  ],
  "afterward": [
    "\"Needs update\" is only a reminder; it does not change your team, registration or submission progress",
    "Finish before the registration deadline; you cannot save after it passes",
    "If it still shows, check for an unticked required checkbox or a newly added required field"
  ],
  "nextSteps": "Next, go to the submission form and prepare the work you will submit.",
  "faq": [
    {
      "q": "Will my registration be cancelled?",
      "a": "No. \"Needs update\" is only a reminder. The system does not cancel your registration or change your team or submission status."
    },
    {
      "q": "Why do I need to update something I already completed?",
      "a": "After you register, the organizer may change the registration form (for example by adding a required field). Older answers that lack the new field, or a required checkbox that is not ticked, are flagged as needing an update."
    },
    {
      "q": "How can I tell a reminder email from the organizer is genuine?",
      "a": "It is sent only to you, lists only the names of the missing fields, never asks for a password or personal data, and ends with the competition's organizer contact email. Sign in on the platform website to update, do not click unfamiliar links, and never reply with a password."
    },
    {
      "q": "I don't see the \"Fill in registration\" button?",
      "a": "After the registration deadline you can no longer save, so the button does not appear. Go by the deadline of the current round shown on the competition page and contact the organizer through the contact email."
    }
  ]
}
